export const ROLESBD = Object.freeze({
    SUPERUSER: "Super User",
    CDVP: "Regional Manager",
    BRANCH_MANAGER: "Area Manager",
    ASM: "Senior/ Territory Manager",
    SUPERVISOR: "Operations Manager",
    TEAM_LEAD: "Field Sale Executive"
  });
  